import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import content from '../data/content.json';

const Footer = () => {
  const { footer, company } = content;
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: 'var(--bg-section)', borderTop: '1px solid var(--border-light)' }}>
      {/* Main Footer Content */}
      <div className="container">
        <div className="pad-xl">
          <div className="grid lg:grid-cols-5 md:grid-cols-2 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <img
                  src="/automation1st-logo.png"
                  alt={company.name}
                  className="h-8 w-auto"
                />
              </Link>
              <p className="body-medium mb-6" style={{ color: 'var(--text-secondary)' }}>
                {footer.description}
              </p>
              
              {/* Contact Info */}
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <Mail className="h-5 w-5 text-blue" />
                  <span className="body-medium">{company.email}</span>
                </div>
                <div className="flex items-center gap-3">
                  <MapPin className="h-5 w-5 text-blue" />
                  <span className="body-medium">{company.location}</span>
                </div>
              </div>
            </div>

            {/* Services */}
            <div>
              <h4 className="heading-3 mb-4">Services</h4>
              <ul className="space-y-3">
                {footer.servicesLinks.map((link, index) => (
                  <li key={index}>
                    <Link 
                      to={link.href} 
                      className="body-medium text-gray-600 hover:text-blue-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Resources */}
            <div>
              <h4 className="heading-3 mb-4">Resources</h4>
              <ul className="space-y-3">
                {footer.resourcesLinks.map((link, index) => (
                  <li key={index}>
                    <Link 
                      to={link.href} 
                      className="body-medium text-gray-600 hover:text-blue-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="heading-3 mb-4">Company</h4>
              <ul className="space-y-3">
                {footer.companyLinks.map((link, index) => (
                  <li key={index}>
                    <Link 
                      to={link.href} 
                      className="body-medium text-gray-600 hover:text-blue-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t pad-lg" style={{ borderColor: 'var(--border-light)' }}>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="body-small" style={{ color: 'var(--text-muted)' }}>
              {footer.copyright.replace('2026', currentYear)}
            </div>
            
            <div className="flex gap-6">
              {footer.legalLinks.map((link, index) => (
                <Link 
                  key={index}
                  to={link.href} 
                  className="body-small text-gray-600 hover:text-blue-600 transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
